import React, { useEffect, useState } from "react";
import { Form, Input, Spin, Modal } from "antd";
import { FormConfig } from "../../../../../shared/config/GlobalConfig";
import ReferenciasApi from "../../../../referencias/api/ReferenciasApi";
import Utils from "../../../../../shared/helpers/utils";
import ReferenciaSelectFormItem from "../../../../../shared/components/referenciaSelectFormItem";
import CampoObligatorio from "../../../../../shared/components/campoObligatorio";

const FormItem = Form.Item;

const AnexoIPuestoModal = props => {
  const [ciuos, setCiuos] = useState([]);
  const [working, setWorking] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    ReferenciasApi.GetTabla("SINIESTRALIDAD.CIUO88").then((response) => { setCiuos(response); })
  }, []);

  useEffect(() => {
    if(props.visible === true){ form.resetFields(); }
  }, [props.visible]);

  const handleOk = () => {
    form.validateFields()
      .then(values => {
        props.onOk({ 
          Hash: props.puesto ? props.puesto.Hash : Utils.generateHash(), 
          ...values 
        });
      });
  }

  return (
    <Modal 
      title={`${props.puesto ? 'Editar' : 'Agregar'} Puesto`}
      width="60%"
      visible={ props.visible }
      onOk={ handleOk }
      onCancel={ props.onCancel }
    >
      <Spin spinning={ working }>
        <Form
          { ...FormConfig.DefaultLayout }
          form={ form }
          name="formulario"
          initialValues={{ ...props.puesto }}
          scrollToFirstError
        >
          { props.puesto?.IdPuesto ? <FormItem name="IdPuesto" label="Puesto" rules={ FormConfig.DefaultRules }>
            <Input disabled/>
          </FormItem> : '' }

          <FormItem name="Nombre" label="Nombre" rules={ FormConfig.DefaultRules }>
            <Input />
          </FormItem>

          <ReferenciaSelectFormItem name="Ciuo" label="Ciuo" 
            rules={ FormConfig.DefaultRules } 
            tabla={ ciuos }
          />

          <CampoObligatorio/>
          
        </Form>
      </Spin>
    </Modal>
  );
}

export default AnexoIPuestoModal;